import { createContext } from "react";

import { Variant } from "@amplitude/experiment-js-client";
import { AmplitudeVariantValue } from "@simplyk/common";

import { AmplitudeEvents } from "@/common/constants/amplitude";

export type Primitive = string | number | boolean;
export type GetExperimentValueProps = {
  flagKey: string;
  userId?: string;
  organizationId?: string;
  userProperties?: Record<string, Primitive>;
  organizationProperties?: Record<string, Primitive>;
  signal?: AbortSignal;
};

interface AmplitudeContextProps {
  getExperimentValue: (props: GetExperimentValueProps) => Promise<Variant | undefined | null>;
  logAmplitudeEvent: (event: AmplitudeEvents | string, payload?: { [key: string]: unknown }) => void;
  resetAmplitude: () => void;
  isAmplitudeLoading: boolean;
  getAmplitudeDeviceId: () => string | undefined;
}

export const AmplitudeContext = createContext<AmplitudeContextProps>({
  getExperimentValue: async () => ({ value: AmplitudeVariantValue.OFF }),
  logAmplitudeEvent: () => {},
  resetAmplitude: () => {},
  isAmplitudeLoading: true,
  getAmplitudeDeviceId: () => undefined,
});
